import { lazy } from "react";

const HostDetail = lazy(() => import("features/Host/Detail"));
const HostDashboard = lazy(() => import("features/Host/Dashboard"));

export const HOST_DETAIL_PATH = "/markets/host/:id/detail";
export const HOST_DASHBOARD_PATH = "/markets/host/dashboard";

export const hostRoutes = [
  {
    path: HOST_DETAIL_PATH,
    component: <HostDetail />,
  },
  {
    path: HOST_DASHBOARD_PATH,
    component: <HostDashboard />,
  },
];
